export default "__VITE_ASSET__29ccc48d__"